import { render, staticRenderFns } from "./PlatformsEdit.vue?vue&type=template&id=b7dc2020&"
import script from "./PlatformsEdit.vue?vue&type=script&lang=js&"
export * from "./PlatformsEdit.vue?vue&type=script&lang=js&"
import style0 from "./PlatformsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports